import { ChangeDetectionStrategy, Component, OnChanges, OnInit, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { CategoryView } from 'ish-core/models/category-view/category-view.model';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';
import { SharedModule } from 'ish-shared/shared.module';

@Component({
  selector: 'ish-category-products',
  templateUrl: './category-products.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbCollapse, SharedModule, FaIconComponent, TranslateModule],
})
export class CategoryProductsComponent implements OnInit, OnChanges {
  /**
   * The the category leading to the displayed result.
   */
  readonly category = input.required<CategoryView>();
  readonly deviceType = input<DeviceType>(undefined);

  isCollapsed = false;

  ngOnInit() {
    this.isCollapsed = this.deviceType() === 'mobile';
  }

  ngOnChanges() {
    if (!SSR) {
      window.scroll(0, 0);
    }
    this.isCollapsed = this.deviceType() === 'mobile';
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    if (!SSR) {
      window.scroll(0, 0);
    }
  }
}
